// eslint-disable-next-line import/no-cycle
import { constructSizes } from '../image';
export var layoutOptions = Object.freeze({
  ONE_COLUMN_NARROW: '1 Column - Narrow',
  ONE_COLUMN_MID: '1 Column - Mid',
  ONE_COLUMN_WIDE: '1 Column - Wide',
  TWO_COLUMNS_WIDE_SPLIT: '2 Columns - Wide Split',
  TWO_COLUMNS_RIGHT_FEATURE: '2 Columns - Right Feature',
  TWO_COLUMNS_LEFT_FEATURE: '2 Columns - Left Feature',
  TWO_COLUMNS_NARROW_SPLIT: '2 Columns - Narrow Split',
  THREE_COLUMNS: '3 Columns',
  FOUR_COLUMNS_WIDE: '4 Columns - Wide'
});
export var layoutClasses = {
  'One Column': 'oneColumn',
  // deprecated
  'Two Column': 'twoColumn',
  // deprecated
  'Three Column': 'threeColumn',
  // deprecated
  [layoutOptions.ONE_COLUMN_WIDE]: 'oneColumn',
  [layoutOptions.ONE_COLUMN_MID]: 'oneColumnMid',
  [layoutOptions.ONE_COLUMN_NARROW]: 'oneColumnNarrow',
  [layoutOptions.TWO_COLUMNS_WIDE_SPLIT]: 'twoColumn',
  [layoutOptions.TWO_COLUMNS_RIGHT_FEATURE]: 'twoColumnRight',
  [layoutOptions.TWO_COLUMNS_LEFT_FEATURE]: 'twoColumnLeft',
  [layoutOptions.TWO_COLUMNS_NARROW_SPLIT]: 'twoColumnNarrowSplit',
  [layoutOptions.THREE_COLUMNS]: 'threeColumn',
  [layoutOptions.FOUR_COLUMNS_WIDE]: 'fourColumn'
};

/**
 * Returns an array corresponding with the number of grid columns,
 * where each array item is an object of props to be passed to the Image component.
 * @param {String} gridLayout - the value of the `layout` prop
 * @return {Array}
 */
export var getImageSizesForGridLayout = gridLayout => {
  var imageSizes3Column = {
    maxWidth: 624,
    sizes: constructSizes([{
      breakpoint: '1372px',
      slotSize: '312px'
    }, {
      breakpoint: '992px',
      slotSize: '22vw'
    }, {
      breakpoint: '768px',
      slotSize: '21vw'
    }, {
      slotSize: '97vw'
    }])
  };
  var imageSizes4Column = {
    maxWidth: 848,
    sizes: constructSizes([{
      breakpoint: '1372px',
      slotSize: '424px'
    }, {
      breakpoint: '992px',
      slotSize: '30vw'
    }, {
      breakpoint: '768px',
      slotSize: '31vw'
    }, {
      slotSize: '97vw'
    }])
  };
  var imageSizes6Column = {
    maxWidth: 1300,
    sizes: constructSizes([{
      breakpoint: '1372px',
      slotSize: '649px'
    }, {
      breakpoint: '992px',
      slotSize: '46vw'
    }, {
      breakpoint: '768px',
      slotSize: '45vw'
    }, {
      slotSize: '97vw'
    }])
  };
  var imageSizes8Column = {
    maxWidth: 1746,
    sizes: constructSizes([{
      breakpoint: '1372px',
      slotSize: '873px'
    }, {
      breakpoint: '992px',
      slotSize: '63vw'
    }, {
      breakpoint: '768px',
      slotSize: '63vw'
    }, {
      slotSize: '97vw'
    }])
  };
  var imageSizes12Column = {
    maxWidth: 2644,
    sizes: constructSizes([{
      breakpoint: '1372px',
      slotSize: '1322px'
    }, {
      breakpoint: '992px',
      slotSize: '95vw'
    }, {
      breakpoint: '768px',
      slotSize: '96vw'
    }, {
      slotSize: '97vw'
    }])
  };
  var imageSizes;
  switch (gridLayout) {
    case layoutOptions.ONE_COLUMN_NARROW:
      imageSizes = [imageSizes6Column];
      break;
    case layoutOptions.ONE_COLUMN_MID:
      imageSizes = [imageSizes8Column];
      break;
    case layoutOptions.ONE_COLUMN_WIDE:
      imageSizes = [imageSizes12Column];
      break;
    case layoutOptions.TWO_COLUMNS_LEFT_FEATURE:
      imageSizes = [imageSizes8Column, imageSizes4Column];
      break;
    case layoutOptions.TWO_COLUMNS_NARROW_SPLIT:
      imageSizes = [imageSizes3Column, imageSizes3Column];
      break;
    case layoutOptions.TWO_COLUMNS_RIGHT_FEATURE:
      imageSizes = [imageSizes4Column, imageSizes8Column];
      break;
    case layoutOptions.TWO_COLUMNS_WIDE_SPLIT:
      imageSizes = [imageSizes6Column, imageSizes6Column];
      break;
    case layoutOptions.THREE_COLUMNS:
      imageSizes = [imageSizes4Column, imageSizes4Column, imageSizes4Column];
      break;
    case layoutOptions.FOUR_COLUMNS_WIDE:
      imageSizes = [imageSizes3Column, imageSizes3Column, imageSizes3Column, imageSizes3Column];
      break;
    default:
      imageSizes = [imageSizes12Column];
  }
  return imageSizes;
};